var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tabActive[data-v-49f12758] {\n  background-color: #12bcf1;\n  color: white;\n}\n.new-button.pull-right[data-v-49f12758] {\n  width: 125px;\n  margin-right: 0px;\n}\n.page[data-v-49f12758] {\n  overflow-y: auto;\n}\n.rowBackgroundImage[data-v-49f12758] {\n  background-image: url(" + escape(require("../../../assets/static/images/MenuFont.png")) + ");\n  background-size: contain;\n}\n@media (max-width: 768px) {\n.toolbarPageBottomBlank[data-v-49f12758] {\n    height: 75px !important;\n}\n}\n@media (min-width: 993px) {\n.searchForm[data-v-49f12758] {\n    margin-top: 0%;\n}\n.heightifLargeScreen[data-v-49f12758] {\n    overflow-y: auto;\n    height: 105%;\n}\n.contactButtonContainer[data-v-49f12758] {\n    margin-top: 0% !important;\n    margin-left:0px\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49f12758","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/services/payments/CMSendboxPage.vue
// module id = 1132
// module chunks = 2